import { render, staticRenderFns } from "./saticitanit.vue?vue&type=template&id=018a2286&"
import script from "./saticitanit.vue?vue&type=script&lang=js&"
export * from "./saticitanit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports